import * as React from 'react';
import { useLogout } from 'src/hooks/api/fetchApi';
import Button from './Button';
import { ExitIcon } from '@radix-ui/react-icons';

interface IProps {}

const LogoutButton: React.FC<IProps> = ({}) => {
  const logout = useLogout();
  return (
    <Button onClick={logout}>
      <ExitIcon />
    </Button>
  );
};

export default LogoutButton;
